import {
  useApiMutation,
  useApiQuery,
  queryClient,
} from "../services/react-query";
import { callApi } from "../services/api";

export const useGetAllCampaigns = (params) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["campaigns", params],
    },
    fetchOptions: {
      url: `/events/${params.eventId}/campaigns`,
      method: "GET",
      params,
    },
  });

export const useGetCampaign = ({ id, eventId }) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["campaign", { id }],
      enabled: !!id,
    },
    fetchOptions: { url: `/events/${eventId}/campaigns/${id}`, method: "GET" },
  });

export const useCreateCampaign = (eventId) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCreateCampaign" },
    fetchOptions: { url: `/events/${eventId}/campaigns`, method: "POST" },
    invalidateQueryKeys: [["campaigns"]],
    successMessage: { title: "Campaign has been created", color: "green" },
  });

export const usePatchCampaign = ({ eventId, id }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "usePatchCampaign" },
    fetchOptions: {
      url: `/events/${eventId}/campaigns/${id}`,
      method: "PATCH",
    },
    invalidateQueryKeys: [["campaigns"], ["campaign", { id }]],
    successMessage: { title: "Campaign has been updated", color: "green" },
  });

export const useDeleteCampaign = ({ eventId }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteCampaign" },
    fetchOptions: {
      url: `/events/${eventId}/campaigns`,
      method: "DELETE",
    },
    invalidateQueryKeys: [["campaigns"]],
    successMessage: { title: "Campaign has been deleted", color: "green" },
  });

export const useSendCampaign = ({ eventId }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useSendCampaign" },
    fetchOptions: {
      url: `/events/${eventId}/campaigns/send`,
      method: "POST",
    },
    invalidateQueryKeys: [["campaigns"], ["campaign"], ["campaignLogs"]],
    successMessage: { title: "Campaign has been sent", color: "green" },
  });

export const useSendCampaignToTicket = ({ eventId, ticketId, campaignId }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useSendCampaignToTicket" },
    fetchOptions: {
      url: `/events/${eventId}/campaigns/${campaignId}/send-to-ticket/${ticketId}`,
      method: "POST",
    },
    invalidateQueryKeys: [["campaignLogs"]],
    successMessage: { title: "Campaign has been sent", color: "green" },
  });

export const useScheduleCampaign = ({ eventId }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useScheduleCampaign" },
    fetchOptions: {
      url: `/events/${eventId}/campaigns/schedule`,
      method: "POST",
    },
    invalidateQueryKeys: [["campaigns"], ["campaign"]],
    successMessage: { title: "Campaign has been scheduled", color: "green" },
  });

export const useCancelScheduleCampaign = ({ eventId }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useCancelScheduleCampaign" },
    fetchOptions: {
      url: `/events/${eventId}/campaigns/cancel-schedule`,
      method: "POST",
    },
    invalidateQueryKeys: [["campaigns"], ["campaign"]],
    successMessage: {
      title: "Campaign schedule has been canceled",
      color: "green",
    },
  });

export const useGetEmailLayout = (eventId) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["emailLayout", eventId],
      enabled: !!eventId,
      staleTime: 5 * 60 * 1000,
    },
    fetchOptions: {
      url: `/email/template/layout`,
      method: "GET",
      params: { eventId },
    },
  });

export const useGetCampaignRecipientCount = ({ eventId, tagIds }) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["campaignRecipientCount", { eventId, tagIds }],
      enabled: !!eventId && !!tagIds && tagIds.length > 0,
    },
    fetchOptions: {
      url: `/events/${eventId}/campaigns/recipient-count`,
      method: "GET",
      params: { tagIds: tagIds?.join(",") },
    },
  });

export const useGetCampaignLogs = (params) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["campaignLogs", { params }],
      enabled: !!params.id,
    },
    fetchOptions: {
      url: `/events/${params.eventId}/campaigns/${params.id}/logs`,
      method: "GET",
      params,
    },
  });

export const fetchCampaignTemplateBody = ({ templateName, eventId }) =>
  queryClient.fetchQuery({
    queryKey: ["campaignTemplateBody", templateName, eventId],
    queryFn: () =>
      callApi({
        url: `/email/template/${templateName}/campaign-body${
          eventId ? `?eventId=${eventId}` : ""
        }`,
        method: "GET",
        token: localStorage.getItem("token"),
      }),
  });
